import { render, staticRenderFns } from "./gsing.component.vue?vue&type=template&id=2d492bbe"
import script from "./gsing.component.ts?vue&type=script&lang=ts&external"
export * from "./gsing.component.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports